import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

// 定义接口返回的数据结构
interface ApiResponse<T = any> {
  code: number;
  message: string;
  data: T;
  rows: T;
}
class HttpClient {
  private instance: AxiosInstance;
  constructor(baseURL = "") {
    this.instance = axios.create({
      baseURL,
      timeout: 10000, // 请求超时时间
      headers: {
        "Content-Type": "application/json",
      },
    });

    // 请求拦截器
    // this.instance.interceptors.request.use(
    //   (config) => {
    //     const token = localStorage.getItem("token");
    //     if (token) {
    //       config.headers.Authorization = `${token}`;
    //     }
    //     return config;
    //   },
    //   (error) => {
    //     return Promise.reject(error);
    //   }
    // );

    // 响应拦截器
    this.instance.interceptors.response.use(
      (response: any) => {
        // 如果返回的数据有 code 字段，才进行判断
        if (response.data && response.data.code !== undefined) {
          if (response.data.code !== 200) {
            return Promise.reject(response.data.message);
          }
          return response.data;
        }
        // 如果没有 code 字段，直接返回原始数据
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  // 封装 GET 请求
  public async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.get(url, config);
  }

  // 封装 POST 请求
  public async post<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return this.instance.post(url, data, config);
  }

  // 封装 PUT 请求
  public async put<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return this.instance.put(url, data, config);
  }

  // 封装 DELETE 请求
  public async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.delete(url, config);
  }
}

// 开发构建（npm run serve）固定走同源 /api/front，由 vue.config.js 代理到远端；
// 避免 .env 里误配成绝对外域 URL 时直连触发 CORS。
const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.VUE_APP_API_PROFILE_PROD
    : "/api/front"; // 开发环境使用相对路径，通过代理转发避免 CORS 问题

// 创建实例并导出
const http = new HttpClient(baseURL);
export default http;
